import { Navigate } from "react-router-dom";

interface UnprotectedRouteProps {
  element: React.ReactElement;
}

const UnprotectedRoute = ({ element }: UnprotectedRouteProps) => {
  return localStorage.getItem("access_token")
    ? <Navigate to="/" replace />
    : element;
};

export default UnprotectedRoute;